var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"show":_vm.loading,"rounded":"sm"}},[_c('div',{staticClass:"srt-embed-container",class:{ dark: _vm.isDarkMode }},[_c('div',{attrs:{"id":("srt-embed-root-" + _vm.currentAgencyId)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }